<template>
  <div>
    <div id="singleModule">
      <div class="moduleContainer">
        <el-row class="phoneContact">
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" class="box">
            <div class="name">上海浦东丽思卡尔顿酒店</div>
            <div class="hotleAddress">
              浦东陆家嘴世纪大道8号, 上海国金中心
            </div>
            <div class="name">机场交通信息</div>
            <div class="flex">
              <div class="flexbox">
                <div class="flexItem">上海虹桥国际机场</div>
                <div class="flexItem">
                  距离酒店：25公里
                </div>
              </div>
              <div class="flexbox">
                <div class="flexItem">上海浦东国际机场</div>
                <div class="flexItem">
                  距离酒店：40公里
                </div>
              </div>
            </div>
            <!-- 火车信息 -->
            <div class="name">火车站交通信息</div>
            <div class="flex">
              <div class="flexbox">
                <div class="flexItem">上海火车站</div>
                <div class="flexItem">
                  距离酒店：9公里
                </div>
              </div>
              <div class="flexbox">
                <div class="flexItem">上海虹桥火车站</div>
                <div class="flexItem">
                  距离酒店：23公里
                </div>
              </div>
            </div>
            <!-- 地铁信息 -->
            <div class="name">地铁交通信息</div>
            <div class="flex">
              <div class="flexbox">
                <div class="flexItem">地铁二号线陆家嘴站</div>
                <div class="flexItem">
                  距离酒店：0.5公里，步行2分钟
                </div>
              </div>
            </div>

          </el-col>

          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" class="box" style="text-align: center;">
            <el-image class="arriveImg"  :src="url" :preview-src-list="srcList">
            </el-image>
          </el-col>

        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "wmt-arriveDetail",

  data() {
    return {
      url: 'https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/CEO%20summits/img/arriveMap.jpeg',
      srcList: ['https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/CEO%20summits/img/arriveMap.jpeg']
    };
  },

  mounted() {
  },
  methods: {},
};
</script>

<style lang="less" scoped>
#singleModule {
  height: auto !important;
  background: #fff !important;
}

.phoneContact {
  padding: 0 20px;
  background: #fff;
  // height: 440px;
  text-align: left;
  margin-top: 14px;
  .arriveImg {
    width: 300px;
    height: 300px;
    margin-top: 50px;
  }
  .box {
    // padding-top: 20px;
    // padding-left: 14px;
   
    .name {
      font-size: 16px;
      margin-top: 20px;
      font-weight: 500;
      margin-bottom: 10px;
      color: #333333;
    }
    .hotleAddress {
      color: #555;
      font-weight: 300;
      font-size: 16px;
    }
    .flex {
      display: block;
      .flexbox {
        color: #555;
        font-weight: 300;
        font-size: 16px;
        margin-right: 78px;
        margin-bottom: 20px;
      }
      .flexItem {
        color: #555;
        font-weight: 300;
        font-size: 16px;
        margin-bottom: 10px;
      }
    }
  }
}
.contactBox {
  background: #fff;
  .arriveImg {
    width: 500px;
    height: 600px;
    margin-top: 50px;
  }
  .box {
    // padding-left: 200px;
    text-align: center;
    .name {
      margin-top: 50px;
      font-size: 18px;
      font-weight: 500;
      color: #333333;
      margin-bottom: 12px;
    }
    .hotleAddress {
      color: #555;
      font-weight: 300;
      font-size: 18px;
    }
    .flex {
      display: flex;
      .flexbox {
        color: #555;
        font-weight: 300;
        font-size: 18px;
        margin-right: 78px;
      }
      .flexItem {
        color: #555;
        font-weight: 300;
        font-size: 18px;
        margin-bottom: 10px;
      }
    }
  }
}
</style>